module.exports = __webpack_public_path__ + "img/preview-consulting.6d5ebda5.png";